// @ts-nocheck
if (!customElements.get("header-menu")) {
  class HeaderMenu extends HTMLElement {
    connectedCallback() {
      // Set initial colors on root and disable transition to prevent flash
      const root = document.documentElement;

      // Check if URL contains "/policies/" - apply white header with blue text
      const isPoliciesPage = window.location.pathname.includes("/policies/");

      root.style.transition = "none";

      if (isPoliciesPage) {
        // Apply white background with blue text for policies pages
        root.style.setProperty(
          "--custom-nav-bg-color",
          "var(--custom-color-white)"
        );
        root.style.setProperty(
          "--custom-nav-text-color",
          "var(--custom-color-blue)"
        );
        root.style.setProperty("--custom-nav-logo-light-display", "none");
        root.style.setProperty("--custom-nav-logo-dark-display", "block");
        root.style.setProperty("--header-logo-mobile-opacity", "0");

        // Add spacing to push content down
        document.body.style.paddingTop = "96px";
      } else if (window.scrollY === 0) {
        root.style.setProperty("--custom-nav-bg-color", "transparent");
        root.style.setProperty("--custom-nav-text-color", "#ffffff");
        root.style.setProperty("--custom-nav-logo-light-display", "block");
        root.style.setProperty("--custom-nav-logo-dark-display", "none");
        root.style.setProperty("--header-logo-mobile-opacity", "1");
      }

      queueMicrotask(() => {
        this.init();
      });
    }

    init() {
      this.drawer = this.querySelector("[data-menu-drawer]");
      this.overlay = this.querySelector("[data-menu-overlay]");
      this.trigger = this.querySelector("[data-menu-trigger]");
      this.closeBtn = this.querySelector("[data-menu-close]");
      this.header = this.closest("header") || document.querySelector("header");
      this.isOpen = false;

      if (this.trigger) {
        this.trigger.addEventListener("click", (e) => {
          e.preventDefault();
          this.open();
        });
      }

      if (this.closeBtn) {
        this.closeBtn.addEventListener("click", (e) => {
          e.preventDefault();
          this.close();
        });
      }

      if (this.overlay) {
        this.overlay.addEventListener("click", () => {
          this.close();
        });
      }

      // Close on Escape key
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && this.isOpen) {
          this.close();
        }
      });

      // Focus trap
      if (this.drawer) {
        this.drawer.addEventListener("keydown", (e) => {
          if (e.key === "Tab" && this.isOpen) {
            this.handleFocusTrap(e);
          }
        });
      }

      // Set initial header colors based on scroll position
      this.updateHeaderColors();

      // Re-enable transition after initial setup
      document.documentElement.style.transition = "";
      if (this.header) {
        this.header.style.transition = "";
      }

      // Scroll listener for header styling
      window.addEventListener("scroll", () => {
        this.updateHeaderColors();
      });
    }

    // Sections can mark themselves with data-header-zone="light" (transparent nav, white text)
    // or data-header-zone="dark" (transparent nav, blue text). The zone sitting under the nav
    // wins; the last matching element in DOM order is treated as the top-most. Legacy:
    // [data-header-transparent-until] behaves like zone="light".
    getHeaderZone() {
      const headerHeight = this.header ? this.header.offsetHeight : 0;
      const probeY = Math.max(1, headerHeight - 1);
      const zones = document.querySelectorAll("[data-header-zone], [data-header-transparent-until]");
      if (!zones.length) return window.scrollY > 0 ? "solid" : "light";
      let zone = "solid";
      zones.forEach((el) => {
        // data-header-zone-scroll="top": the zone only applies while the page is at the very top
        if (el.getAttribute("data-header-zone-scroll") === "top" && window.scrollY > 8) return;
        const r = el.getBoundingClientRect();
        if (r.top <= probeY && r.bottom > probeY) {
          zone = el.getAttribute("data-header-zone") || "light";
        }
      });
      return zone;
    }

    updateHeaderColors() {
      const root = document.documentElement;
      const isPoliciesPage = window.location.pathname.includes("/policies/");

      // For policies pages, always use white background with blue text
      if (isPoliciesPage) {
        root.style.setProperty(
          "--custom-nav-bg-color",
          "var(--custom-color-white)"
        );
        root.style.setProperty(
          "--custom-nav-text-color",
          "var(--custom-color-blue)"
        );
        root.style.setProperty("--custom-nav-logo-light-display", "none");
        root.style.setProperty("--custom-nav-logo-dark-display", "block");
        root.style.setProperty("--header-logo-mobile-opacity", "0");
      } else if (this.getHeaderZone() === "solid") {
        // For other pages, change to white on scroll
        root.dataset.navZone = "solid";
        root.style.setProperty(
          "--custom-nav-bg-color",
          "var(--custom-color-white)"
        );
        root.style.setProperty(
          "--custom-nav-text-color",
          "var(--custom-color-blue)"
        );
        root.style.setProperty("--custom-nav-logo-light-display", "none");
        root.style.setProperty("--custom-nav-logo-dark-display", "block");
        root.style.setProperty("--header-logo-mobile-opacity", "0");
      } else if (this.getHeaderZone() === "dark") {
        // Transparent nav over a light section: blue text and logo
        root.dataset.navZone = "dark";
        root.style.setProperty("--custom-nav-bg-color", "transparent");
        root.style.setProperty(
          "--custom-nav-text-color",
          "var(--custom-color-blue)"
        );
        root.style.setProperty("--custom-nav-logo-light-display", "none");
        root.style.setProperty("--custom-nav-logo-dark-display", "block");
        root.style.setProperty("--header-logo-mobile-opacity", "0");
      } else {
        root.dataset.navZone = "light";
        // Default transparent header at top
        root.style.setProperty("--custom-nav-bg-color", "transparent");
        root.style.setProperty("--custom-nav-text-color", "#ffffff");
        root.style.setProperty("--custom-nav-logo-light-display", "block");
        root.style.setProperty("--custom-nav-logo-dark-display", "none");
        root.style.setProperty("--header-logo-mobile-opacity", "1");
      }
    }

    getFocusableElements() {
      if (!this.drawer) return [];
      const focusableSelectors =
        "a[href], button:not([disabled]), textarea, input, select";
      return Array.from(this.drawer.querySelectorAll(focusableSelectors));
    }

    handleFocusTrap(e) {
      const focusableElements = this.getFocusableElements();
      if (focusableElements.length === 0) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (e.shiftKey) {
        // Shift + Tab
        if (document.activeElement === firstElement) {
          e.preventDefault();
          lastElement.focus();
        }
      } else {
        // Tab
        if (document.activeElement === lastElement) {
          e.preventDefault();
          firstElement.focus();
        }
      }
    }

    open() {
      this.isOpen = true;

      // Store the element that triggered the menu
      this.previouslyFocusedElement = document.activeElement;

      if (this.drawer) {
        this.drawer.classList.add("custom--active");
        this.drawer.setAttribute("aria-hidden", "false");
      }

      if (this.overlay) {
        this.overlay.classList.add("custom--active");
        this.overlay.setAttribute("aria-hidden", "false");
      }

      if (this.trigger) {
        this.trigger.setAttribute("aria-expanded", "true");
        // Add data attribute to help with CSS targeting
        this.trigger.setAttribute("data-drawer-open", "true");
      }

      document.body.style.overflow = "hidden";

      // Move focus to first focusable element in drawer
      setTimeout(() => {
        const focusableElements = this.getFocusableElements();
        if (focusableElements.length > 0) {
          focusableElements[0].focus();
        }
      }, 50);
    }

    close() {
      this.isOpen = false;

      if (this.drawer) {
        this.drawer.classList.remove("custom--active");
        this.drawer.setAttribute("aria-hidden", "true");
      }

      if (this.overlay) {
        this.overlay.classList.remove("custom--active");
        this.overlay.setAttribute("aria-hidden", "true");
      }

      if (this.trigger) {
        this.trigger.setAttribute("aria-expanded", "false");
        // Remove data attribute to restore hamburger menu visibility
        this.trigger.removeAttribute("data-drawer-open");
      }

      document.body.style.overflow = "";

      // Return focus to trigger button with a slight delay to ensure smooth transition
      if (this.previouslyFocusedElement) {
        setTimeout(() => {
          this.previouslyFocusedElement.focus();
        }, 100);
      }
    }
  }

  customElements.define("header-menu", HeaderMenu);
}
